<div class="pop_overs_title position-relative d-inline-block" tabindex="0" (blur)="togglePopOvers(false)">
    <i 
        (click)="togglePopOvers()"
        class="fa-solid fa-circle-exclamation color_wrong pointer"
    >
    </i>
    <ng-container *ngIf="status">
        <div class="pop_body def_shadow text-center position-absolute" @fade>
            <div class="wrap_body">
                <span class="pop_title d-block text_sm_bold p-1">{{Title}}</span>
                <p class="lead mb-0 label_lg_normal p-1">{{Content}}</p>
            </div>
        </div>
    </ng-container>
</div>